import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
@Pipe({
    name: 'safeTransform'
})
export class SafePipe implements PipeTransform {
    /**
     * @ignore
     */
    constructor(protected sanitizer: DomSanitizer) {
        this.sanitizer = sanitizer;
    }
    /**
     * @description transform
     * @params value
     * @params type
     */
    public transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
        let result: SafeHtml;
        switch (type) {
            case 'html':
                result = this.sanitizer.bypassSecurityTrustHtml(value);
                break;
            case 'style':
                result = this.sanitizer.bypassSecurityTrustStyle(value);
                break;
            case 'script':
                result = this.sanitizer.bypassSecurityTrustScript(value);
                break;
            case 'url':
                result = this.sanitizer.bypassSecurityTrustUrl(value);
                break;
            case 'resourceUrl':
                result = this.sanitizer.bypassSecurityTrustResourceUrl(value);
                break;
            default:
                throw new Error(`Invalid safe type specified: ${type}`);
        }
        return result;
    }
}
